module.exports = __webpack_public_path__ + "img/banner-supplies-mapgrafi-2026.1872a5cd.jpg";